module.exports = __webpack_public_path__ + "static/media/bc.17661182.jpg";